export const ENDPOINTS_CLASSROOM = {
  ACTIVATION_AVAILABLE_NOTEBOOK:
    '/bff-vle/classes/:classId/checkActivationAvailable',
  AVAILABLE_CLASSES_BY_SCHOOL:
    '/bff-vle/schools/:schoolCode/availableClassrooms?publicationId=:publicationId',
  AVAILABLE_CLASSES_BY_TEACHER:
    '/bff-vle/teachers/:teacherId/availableClassesByTeacher',
  CLASSES_ID_GRADE_SYSTEM: '/bff-vle/classes/:classId/gradeSystem',
  CLASS_GRADE_ALGORITHM:
    '/bff-vle/classes/:classId/gradeAlgorithms?userId=:userId',
  CLASS_MEMBERS:
    '/bff-vle/classes/:classId/members?pageStudents=:pageStudents&sizeStudents=:sizeStudents',
  CLASS_TEACHER_TASKS:
    '/bff-vle/classes/:classId/teachers/:teacherId/tasks?taskStatus=:status&page=:page&size=:size',
  CREATE_CLASSES: '/bff-vle/classes/teachers/:teacherId',
  DELETE_CLASS: '/bff-vle/me/classes/:classId',
  DEPRECATED_CLASS_MEMBERS: '/bff-vle/classes/:classId/members',
  FEEDBACK_RESULT: '/bff-vle/classes/:classId/recalculateResults/feedback',
  GRADE_ALGORITHMS: '/bff-vle/gradeAlgorithms',
  MATERIALS: '/bff-vle/classes/:classId/materials?userId=:userId',
  NOTEBOOK: '/bff-vle/classes/:classId/notebooks?userId=:userId',
  RENAME_CLASS: '/bff-vle/classes/:classId',
  REORDER_CLASSES: '/bff-vle/teachers/:teacherId/classes/reorder',
  STUDENT_CLASS: '/bff-vle/students/:studentId/classes/:classId',
  STUDENT_CLASSES: '/bff-vle/students/:studentId/classes',
  STUDENT_TASKS:
    '/bff-vle/classes/:classId/students/:studentId/tasks/:state?taskStatus=:status',
  TASK: '/bff-vle/tasks/:taskId',
  TASKS: '/bff-vle/tasks',
  TASKS_DRAFT: '/bff-vle/tasks/draft',
  TASK_ACTIVE: '/bff-vle/tasks/:taskId/active',
  TASK_CLOSE: '/bff-vle/tasks/:taskId/close',
  TASK_NOTIFICATION: '/bff-vle/notifications/tasks/:taskId/users/:userId',
  TASK_RESULTS:
    '/bff-vle/classes/:classId/results/check?studentIds=:studentsIds&activityIds=:activityIds',
  TASK_STUDENT_REVIEW: '/bff-vle/tasks/:taskId/students/:studentId/review',
  TASK_SUBMISSIONS: '/bff-vle/tasks/:taskId/submissions?page=:page&size=:size',
  TEACHER_CLASSES: '/bff-vle/teachers/:teacherId/classes',
  TEACHER_GROUPED_AVAILABLE_CLASSES:
    '/bff-vle/teachers/:teacherId/availableClassesByTeacher/grouped',
  TEACHER_GROUPED_CLASSES: '/bff-vle/teachers/:teacherId/classes/grouped',
}
